import React from "react";
import "./License.css";

const License = () => {
  return (
    <div className="license">
      <p
        {...{
          "xmlns:cc": "http://creativecommons.org/ns",
          "xmlns:dct": "http://purl.org/dc/terms/",
        }}
      >
        <a
          property="dct:title"
          rel="cc:attributionURL"
          href="http://www.prideflagproject.com"
        >
          Pick & Mix Personalized Pride Flag Project
        </a>{" "}
        by{" "}
        <a
          rel="cc:attributionURL dct:creator"
          property="cc:attributionName"
          href="https://www.instagram.com/jonhdanderson"
        >
          Jonathan Harry David Anderson
        </a>{" "}
        is licensed under{" "}
        <a
          href="http://creativecommons.org/licenses/by-sa/4.0/?ref=chooser-v1"
          target="_blank"
          rel="license noopener noreferrer"
          style={{ display: "inline-block" }}
        >
          Attribution-ShareAlike 4.0 International
          <img
            alt="cc"
            style={{
              height: "22px",
              marginLeft: "3px",
              verticalAlign: "text-bottom",
            }}
            src="https://mirrors.creativecommons.org/presskit/icons/cc.svg?ref=chooser-v1"
          />
          <img
            alt="cc2"
            style={{
              height: "22px",
              marginLeft: "3px",
              verticalAlign: "text-bottom",
            }}
            src="https://mirrors.creativecommons.org/presskit/icons/by.svg?ref=chooser-v1"
          />
          <img
            alt="cc3"
            style={{
              height: "22px",
              marginLeft: "3px",
              verticalAlign: "text-bottom",
            }}
            src="https://mirrors.creativecommons.org/presskit/icons/sa.svg?ref=chooser-v1"
          />
        </a>
      </p>
    </div>
  );
};

export default License;
